'use client';

import { LockedModule } from '../_components/LockedModule';

export default function AiAgentPage() {
  return (
    <LockedModule
      tier="Premium"
      title="סוכן AI לניהול תורים"
      description="בינה מלאכותית שמנהלת את הלוח שלכם - מאשרת, מסדרת ומגיבה ללקוחות אוטומטית. זמין בתוכנית Premium."
    />
  );
}
